// Actions
import {
  APP_SET_APPLICATION,
  APP_SET_LANGUAGE,
  APP_SET_THEME,
  APP_SET_UNIT_SYSTEM,
  APP_SET_ALARMS,
  APP_SET_ALERTS,
  APP_SET_NOTIFICATION_LEVELS,
  APP_RESET_NOTIFICATION_PREFERENCES,
} from '../actionTypes';

export const initialState = {
  theme: 'default',
  unitSystem: null,
  language: null,
  alarms: true,
  alerts: true,
  notificationLevels: [],
  application: {},
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case APP_SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case APP_SET_UNIT_SYSTEM:
      return {
        ...state,
        unitSystem: action.payload,
      };
    case APP_SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case APP_SET_APPLICATION:
      return {
        ...state,
        application: action.payload,
      };
    case APP_SET_ALARMS:
      return {
        ...state,
        alarms: action.payload,
      };
    case APP_SET_ALERTS:
      return {
        ...state,
        alerts: action.payload,
      };
    case APP_SET_NOTIFICATION_LEVELS:
      return {
        ...state,
        notificationLevels: action.payload,
      };
    case APP_RESET_NOTIFICATION_PREFERENCES:
      return {
        ...state,
        alarms: initialState.alarms,
        alerts: initialState.alerts,
        notificationLevels: initialState.notificationLevels,
      };
    default:
      return state;
  }
};
